import { UntypedFormGroup } from '@angular/forms';
import { AllControlsConfiguration } from '@zipari/shared-ds-util-form';

export interface ValidatorConfig {
  date?: string;
  dependency?: string;
  message?: string;
  name: string;
}

export type DateRangeConfig = AllControlsConfiguration & {
  end_date_validators?: ValidatorConfig[];
  endProp?: string;
  start_date_validators?: ValidatorConfig[];
  startProp?: string;
  validators?: ValidatorConfig[];
};

export interface DateRangeValue {
  end: string;
  start: string;
}

export interface ControlDateRangeArgs {
  config: DateRangeConfig;
  group: UntypedFormGroup;
  ariaLabel: string;
}
